<template>
  <div class="w-full flex">
    <div class="w-full">
      <Header
        title="Brained Marcom"
        description="MARCOM is your dedicated marketing campaign tool. Use it to create, launch, and track the performance of your brand's marketing campaigns."
      />
      <div class="fixed-top menucontrol-scroll">
        <div class="flex w-full p-6 bg-white">
          <div
            v-if="
              (userModules &&
                (userModules.includes('Branding') ||
                  userModules.includes('Marcom'))) ||
              ['Admin', 'Developer'].includes(login.role)
            "
            class="w-4/12 pr-4"
          >
            <!-- <Plans /> -->
            <CampaignStatus />
            <!-- <el-card class="elshadow mb-6">
              <div class="flex">
                <img
                  src="@/builder/NewScreen/img/pm/pm.png"
                  alt="image"
                  class="avatar-imgw"
                />
                <div class="pl-4">
                  <h2 class="fsize16 text-black">Project Manager</h2>
                  <p class="text-success mb-2">Online</p>

                  <div>
                    <img
                      src="@/builder/NewScreen/img/1.jpg"
                      alt="image"
                      class="w-6 h-6 rounded-full"
                    />
                    <img
                      src="@/builder/NewScreen/img/2.jpg"
                      alt="image"
                      class="w-6 h-6 rounded-full"
                    />
                    <img
                      src="@/builder/NewScreen/img/3.jpg"
                      alt="image"
                      class="w-6 h-6 rounded-full"
                    />
                  </div>
                </div>
              </div>

              <div class="mt-8">
                <h4 class="font-semibold fsize16 text-4f4f4f">Overview</h4>
                <p class="text-929292">
                  A Business Analyst defines your business technology based on
                  requirements you defined.
                </p>
                <p class="pt-1 text-929292">
                  Your requirments are translated into userstories that help you
                  identify user roles,Pages & user activities.
                </p>
              </div>
            </el-card>

            <el-card class="elshadow">
              <div>
                <p class="text-builderprimary mb-1 fsize12">
                  Frequently Asked Questions
                </p>
                <h2 class="text-4f4f4f fsize16">
                  You got questions, we got answers
                </h2>
              </div>

              <div class="mt-6">
                <vs-collapse>
                  <vs-collapse-item class="elcollapse-ct">
                    <div slot="header" class="text-4f4f4f fsize14">
                      How can i connect with my PM?
                    </div>

                    <div>
                      <p class="fsize14">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Quisque rhoncus eros tortor, non fringilla lectus cursus
                        et. Fusce vel nisi ante. Aliquam sit amet lectus
                        pharetra, luctus mi sed, aliquet felis. Mauris a tortor
                        viverra, ornare tellus in, consectetur leo.
                      </p>
                    </div>
                  </vs-collapse-item>

                  <vs-collapse-item class="elcollapse-ct">
                    <div slot="header" class="text-4f4f4f fsize14">
                      How can i connect with my PM?
                    </div>

                    <div>
                      <p class="fsize14">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Quisque rhoncus eros tortor, non fringilla lectus cursus
                        et. Fusce vel nisi ante. Aliquam sit amet lectus
                        pharetra, luctus mi sed, aliquet felis. Mauris a tortor
                        viverra, ornare tellus in, consectetur leo.
                      </p>
                    </div>
                  </vs-collapse-item>

                  <vs-collapse-item class="elcollapse-ct">
                    <div slot="header" class="text-4f4f4f fsize14">
                      How can i connect with my PM?
                    </div>

                    <div>
                      <p class="fsize14">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Quisque rhoncus eros tortor, non fringilla lectus cursus
                        et. Fusce vel nisi ante. Aliquam sit amet lectus
                        pharetra, luctus mi sed, aliquet felis. Mauris a tortor
                        viverra, ornare tellus in, consectetur leo.
                      </p>
                    </div>
                  </vs-collapse-item>

                  <vs-collapse-item class="elcollapse-ct">
                    <div slot="header" class="text-4f4f4f fsize14">
                      How can i connect with my PM?
                    </div>

                    <div>
                      <p class="fsize14">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Quisque rhoncus eros tortor, non fringilla lectus cursus
                        et. Fusce vel nisi ante. Aliquam sit amet lectus
                        pharetra, luctus mi sed, aliquet felis. Mauris a tortor
                        viverra, ornare tellus in, consectetur leo.
                      </p>
                    </div>
                  </vs-collapse-item>
                </vs-collapse>
              </div>
            </el-card> -->
          </div>

          <div class="w-8/12 pl-4">
            <p class="font-semibold mb-0 text-dark text-2xl">Quick Shortcuts</p>
            <small class="fsize14 text-dark">Create Campaigns on the go</small>
            <div
              v-if="
                (userModules && userModules.includes('Marcom')) ||
                ['Admin', 'Developer'].includes(login.role)
              "
              class="grid grid-cols-4 gap-6 mt-6 mb-8"
            >
              <div
                v-for="(item, index) in CampaignsCard"
                :key="'item-' + index"
                class="text-center cust-shadow bg-white cursor-pointer rounded-4px"
                @click="handleClickCampaign(item)"
              >
                <img
                  :src="item.image"
                  :class="item.class"
                  class="object-contain p-6 w-full h-110px rounded-t-4px"
                  alt="banh"
                />
                <p class="font-semibold truncate fsize12 mb-0 py-2 px-2">
                  {{ item.name }}
                </p>
              </div>
            </div>

            <div
              class="pb-8"
              :class="[
                (userModules && userModules.includes('Marcom')) ||
                ['Admin', 'Developer'].includes(login.role)
                  ? 'mt-6'
                  : 'mt-12',
              ]"
            >
              <div
                class="items-center"
                v-if="
                  (userModules && userModules.includes('Marcom')) ||
                  ['Admin', 'Developer'].includes(login.role)
                "
              >
                <p class="font-semibold mb-0 text-dark text-xl">
                  Setup & Insights
                </p>
                <small class="fsize14 col-4f"
                  >Manage your target audience, addons & insights</small
                >
              </div>

              <div class="grid grid-cols-4 gap-6 mt-6">
                <div
                  v-for="(item, index) in filteredSetupCards"
                  :key="'item-' + index"
                  class="text-center cust-shadow bg-white cursor-pointer rounded-4px"
                  @click="handleClick(item.route, item)"
                >
                  <img
                    :src="item.image"
                    :class="item.class"
                    class="object-contain p-6 w-full h-110px rounded-t-4px"
                    alt="banh"
                  />
                  <p class="font-semibold truncate fsize12 mb-0 py-2 px-2">
                    {{ item.name }}
                  </p>
                </div>
              </div>
            </div>
            <el-dialog
              :visible.sync="centerDialogVisibletr"
              width="30%"
              center
              class="ishidePopup"
            >
              <div class="flex justify-center items-center">
                <div class="">
                  <div class="mt-2">
                    <p class="text-lg font-semibold mb-0 text-black">
                      Phone Number
                    </p>
                    <el-input
                      placeholder="Please input"
                      class="mt-1"
                      name="phone"
                      maxlength="10"
                      v-model="phone"
                      v-validate="'required|numeric|max:10'"
                      data-vv-validate-on="input|blur"
                    ></el-input>
                    <p v-if="errors.has('phone')" class="text-danger">
                      {{ errors.first("phone") }}
                    </p>
                  </div>
                  <div class="mt-2">
                    <p class="text-lg font-semibold mb-0 text-black">
                      Bot Name
                    </p>
                    <el-input
                      placeholder="Please input"
                      class="mt-1"
                      name="botName"
                      v-model="botName"
                      maxlength="50"
                      v-validate="'required|min:2'"
                      data-vv-validate-on="input|blur"
                    ></el-input>
                    <p v-if="errors.has('botName')" class="text-danger">
                      {{ errors.first("botName") }}
                    </p>
                  </div>
                  <div class="mt-2">
                    <p class="fsize12 col-4f">
                      Our representative will configure your request in next
                      24-48 hours.
                    </p>
                  </div>
                  <div class="flex gap-4 justify-center mt-6 items-center">
                    <vs-button
                      type="primary"
                      class="bg-primary w-1/2 rounded-full text-white font-medium fsize14 py-12px px-6"
                      @click="createWhatsappConfig()"
                    >
                      Submit
                    </vs-button>
                    <vs-button
                      type="secondary"
                      class="bg-secondary w-1/2 rounded-full text-white font-medium fsize14 py-12px px-6"
                      @click="
                        () => {
                          centerDialogVisibletr = false;
                        }
                      "
                    >
                      Cancel
                    </vs-button>
                  </div>
                </div>
              </div>
            </el-dialog>
            <!-- <el-dialog
              class="ne-oppop"
              width="35%"
              :visible.sync="centerDialogVisiblehh"
              center
            >
              <div class="p-4 flex justify-between items-center">
                <h2 class="text-white fsize14 my-0">Whatsapp Campaign</h2>
                <feather-icon
                  icon="XIcon"
                  svgClasses="w-4 h-4"
                  class="cursor-pointer text-primary"
                  @click="centerDialogVisiblehh = false"
                />
              </div>

              <div
                class="flex justify-center mt-3 pb-4 px-4 w-full items-center"
              >
                <div class="">
                  <div class="flex justify-center mb-6">
                    <img
                      src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png"
                      class="new-height"
                    />
                  </div>
                  <div class="text-center">
                    <h1 class="fsize20 text-dark font-semibold">
                      Want to setup SenderID?
                    </h1>
                    <p class="fsize14 text-gray my-2">
                      Please click on the below button for step by step
                      procedure
                    </p>
                    <vs-button
                      color="primary"
                      class="px-4 mt-2 bg-primary border-0 text-white font-normal fsize14"
                    >
                      <a
                        href="https://gupshup.io"
                        class="text-white"
                        target="_blank"
                        >Click here to setup</a
                      >
                    </vs-button>
                    <p class="cursor-pointer mt-3 mb-4">
                      Is your Whatsapp Sender ID already setup?<a
                        @click="
                          () => {
                            centerDialogVisiblehh = false;
                            centerDialogVisibletr = true;
                          }
                        "
                        class="ml-1"
                        >Click here</a
                      >
                    </p>
                  </div>
                </div>
              </div>
            </el-dialog> -->
            <!-- <div class="relative mt-4">
              <div class="bg-primary ban-he w-full border-round"></div>
              <div class="absolute top-0 px-10 ban-he flex items-center">
                <div class="">
                  <p class="font-semibold fsize12 text-white flex items-center">
                    BR<span class="col-ffc1">AI</span>NED Studio
                  </p>
                  <h2 class="text-white head-font font-semibold">
                    Get a Digital Marketing Plan <br />
                    with actionables & Creatives
                  </h2>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Plans from "@/views/adminPanel/pages/ecommerce/components/Plans";
import CampaignStatus from "./components/CampaignStatus";
import axios from "axios";
import NotificationUser from "@/views/adminPanel/pages/dashboard/NotificationUser";
import { mapState } from "vuex";
import Header from "@/views/adminPanel/layouts/components/Header";
export default {
  data() {
    return {
      taskList: [],
      circles: 0,
      progress: 50,
      emptyColorFillGradient: "#ececec",
      size: 200,
      centerDialogVisibletr: false,
      centerDialogVisiblehh: false,
      newSetupsignCard: [],
      setupsignCard: [
        {
          name: "Branding",
          image: require("@/assets/images/icons/Branding.svg"),
          route: "branding",
          class: "bg-eb",
          includes: "Branding",
        },
        {
          name: "My Audience",
          image: require("@/assets/images/icons/user management.svg"),
          route: "marcom-Segment",
          class: "bg-eb",
          includes: "Marcom",
        },
        {
          name: "My Campaigns",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/binicular.png",
          route: "marcom-Mycampaign",
          class: "bg-dyellow",
          includes: "Marcom",
        },
        {
          name: "Calendar",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/calendar.png",
          route: "marcom-Calendar",
          class: "bg-dblue",
          includes: "Marcom",
        },
        {
          name: "Templates",
          image: require("@/assets/images/icons/brochures.svg"),
          route: "marcom-Templates",
          class: "bg-yellows",
          includes: "Marcom",
        },
        {
          name: "Landing Page",
          image: require("@/assets/images/icons/copywrite.svg"),
          route: "marcom-landing-page",
          class: "bg-dblue",
          includes: "Landing Page",
        },
        {
          name: "Variable",
          image: require("@/assets/images/icons/Documentation.svg"),
          route: "marcom-variable",
          // route: "coming",
          class: "bg-yellows",
          includes: "Marcom",
        },
      ],
      CampaignsCard: [
        {
          name: "Whatsapp Campaign",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/whatsapp.png",
          route: "whatsapp-Campaign",
          class: "bg-grens",
        },
        {
          name: "SMS Campaign",
          image: require("@/assets/images/airplane.png"),
          route: "SMS-Campaign",
          class: "bg-cas",
        },
        {
          name: "Push Notification",
          image: require("@/assets/images/bell.png"),
          route: "pushNotification-Campaign",
          class: "bg-yellows",
        },

        {
          name: "Email Campaign",
          image: require("@/assets/images/main.png"),
          route: "email-Campaign",
          class: "bg-blues",
        },
      ],
      options: [],
      phone: "",
      botName: "",
    };
  },

  components: {
    Plans,
    CampaignStatus,
    NotificationUser,
    Header,
  },

  computed: {
    ...mapState("admin", ["login", "userModules"]),
    ...mapState("user", ["selectedProject"]),
    ...mapState("marcom", ["taskListUsers"]),
    ...mapState("modules", ["modulesList"]),
    filteredSetupCards() {
      if (
        ["Admin", "Developer"].includes(this.login.role) ||
        this.userModules.includes("Marcom")
      ) {
        return this.setupsignCard;
      } else {
        let array = this.setupsignCard.filter((x) => x.includes == "Branding");
        return array;
      }
    },
  },
  methods: {
    handleClick(name, item) {
      let access = false;
      this.modulesList.forEach((x) => {
        if (x.name === item.name) {
          access = x.access_control;
        }
      });
      if (!access) {
        this.$router.push({ name: "coming" });
      } else {
        this.$router.push({ name: name });
      }
    },
    handleClickCampaign(item) {
      let access = false;
      this.modulesList.forEach((x) => {
        if (x.name === item.name) {
          access = x.access_control;
        }
      });
      if (!access) {
        this.$router.push({ name: "coming" });
      } else {
        if (item.name === "Whatsapp Campaign") {
          this.$router.push({ name: item.route });
          // if (this.options.length > 0) {
          //   this.centerDialogVisibletr = false;
          //   this.$router.push({ name: item.route });
          // } else {
          //   this.phone = "";
          //   this.botName = "";
          //   this.centerDialogVisibletr = true;
          //   this.$validator.reset();
          // }
        } else {
          this.$router.push({ name: item.route });
        }
      }
    },
    async getAllConfigs() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
        projectId: this.selectedProject._id,
      };
      let { data } = await axios.post(
        // "http://localhost:3001/api/marcom/whatsapp/getWhatsappConfig",
        process.env.VUE_APP_BASE_API + "/marcom/whatsapp/getWhatsappConfig",
        payload,
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );
      this.options = data.data;

      // console.log(this.data);
    },
    async createWhatsappConfig() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
        source: this.phone,
        name: this.botName,
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
        user: this.taskListUsers.PM[0]._id,
      };

      this.$validator.validateAll().then(async (result) => {
        if (result) {
          let data = await axios.post(
            process.env.VUE_APP_BASE_API +
              "marcom/whatsapp/createWhatsappConfig",
            // "http://localhost:3001/api/marcom/whatsapp/createWhatsappConfig",
            payload,
            {
              headers: {
                Accept: "application/json",
                "community-name": process.env.VUE_APP_COMMUNITY_NAME,
              },
            }
          );
          this.$swal({
            text: "Successfully Added Member",
            icon: "success",
            confirmButtonColor: "#830c81",
            // cancelButtonColor: "#d33",
            confirmButtonText: "Okay",
          });
          this.centerDialogVisibletr = false;
          //console.log(data, "success");
        }
      });
    },
    async getTaskList() {
      return new Promise(async (resolve, reject) => {
        try {
          // const { data } = await Repository.post(
          //   "/zoho/projects/tasks/tasklist"
          // );
          // console.log(data);

          const { data } = await this.$store.dispatch("builder/getTasklist", {
            // projectName: "testApplication1",
            projectName: process.env.VUE_APP_COMMUNITY_NAME,
          });

          this.taskList = data.map((x) => ({
            text:
              x.name == "Sprint 0" || x.name == "Version 0"
                ? "Default"
                : x.name,
            value: x,
          }));

          // console.log(this.taskList);
          this.$store.commit("marcom/GET_TASK_LIST", {
            key: "taskListUsers",
            value: this.taskList[0].value,
          });

          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
  },

  async mounted() {
    await this.getAllConfigs();
    this.getTaskList();
  },
};
12;
</script>
<style>
.elcollapse-ct {
  border: none !important;
  padding: 0px !important;
  margin-bottom: 12px;
  font-size: 12px !important;
  border-radius: 4px;
  background: #f4f5f6;
}
.elcollapse-ct .vs-collapse-item--header {
  padding: 12px !important;
}
</style>
